import { IOneDriveFolder } from "../../interfaces/IOneDriveFolder";
import { getFolderPathsInfo } from "../../services/GraphService";
import { OneDriveFolderLocationBuilder } from "./sharepointSearch/OneDriveFolderLocationBuilder";
import { OneDriveWorkingDirectoriesBuilder } from "./sharepointSearch/OneDriveWorkingDirectoriesBuilder";
import { IDirectoryBuilder } from "../../interfaces/IDirectoryBuilder";

export class SearchedOneDriveDirectoryBuilder implements IDirectoryBuilder {
    constructor(private webUrl: string, private sharePointListId: string) { }

    async getFolderDirectories(folder: IOneDriveFolder) {
        const folderPathBuilder = new OneDriveFolderLocationBuilder(this.webUrl, this.sharePointListId);
        const paths = await folderPathBuilder.build(folder.webUrl);
        const drives = await getFolderPathsInfo(folder.driveId, paths, true);
        const workingDirectoriesBuilder = new OneDriveWorkingDirectoriesBuilder(folderPathBuilder, drives, this.webUrl, this.sharePointListId);
        return await workingDirectoriesBuilder.build();
    };
}
